<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}">
                <label for="material" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان کالا : </span>
                    <span *ngIf="lang == 2"> Material : </span>
                    <span (click)="reset_input(171)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="material_title" (click)="get_material() "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="material" [hidden]="true" [required]="required()" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}">
                <label for="number" class='wh-label'>
                    <span *ngIf="lang == 1"> تعداد : </span>
                    <span *ngIf="lang == 2"> Number : </span>
                    <input class='wh-input' formControlName="number" autocomplete="off" [required]="required()"
                        pattern="[0-9]{1,}">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> قیمت واحد </span>
                    <span *ngIf="lang == 2"> Price </span>
                    <span *ngIf="currency_title">به {{ currency_title }}</span>
                    <input class='wh-input' formControlName="cost" autocomplete="off" currencyMask
                        [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}"
                [hidden]="ref == 'reception' || ref == 'invoice' ">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت درخواست : </span>
                    <span *ngIf="lang == 2"> Order Status : </span>
                    <span (click)="reset_input(158)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(158) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}" [ngClass]="{width1:ref == 'invoice'}"
                [hidden]="status_id_add != 1 || ref == 'invoice'">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره فاکتور </span>
                    <span *ngIf="lang == 2"> Invoice Number </span>
                    <input class='wh-input' formControlName="invoice" autocomplete="off" [disabled]="true">
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات : </span>
                    <span *ngIf="lang == 2"> Comment : </span>
                    <textarea style="height:10rem" class="wh-input" formControlName="comment"></textarea>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>